<template>
    <div class="common-detail-main guonei-box">
        <div class="bjx-equity">
  
            <cube-tab-panels v-model="selectedLabel">
                <cube-tab-panel :ref="'panel'+index" v-for="(item, index) in tabs" :label="item.label"
                    :key="item.label">
                    <div class="equity-common-content">
                        <div class="e-common-frames" v-if="item.class">
                            <div class="e-top e-common-block">
                                <div class="e-common-lr">
                                    <div class="e-left">
                                        <img src="@/assets/images/e-qgjcvip-icon@2x.png" alt="">
                                    </div>
                                    <div class="e-right">
                                        <h3>全国机场、高铁贵宾接/送服务</h3>
                                        <p>覆盖全国70多个地区，70多个机场和百余个高铁站。接送用车统一采用帕萨特、君越、君威、雅阁、凯美瑞、天籁舒适版等同档次舒适车型或别克GL8商务车型，并配备专业司机。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="e-bottom e-common-block">
                                <h2>温馨提示</h2>
                                <p class="bold">细则1</p>
                                <p>世界白金鑫卡持卡人（以下简称“您”）全年尊享4次全国机场、高铁贵宾接/送服务。</p>
                                <p>钛金鑫卡持卡人全年尊享12次全国机场、高铁贵宾接/送服务。 </p>
                                <p class="bold">细则2</p>
                                <p>本行将在您激活人民币卡后的3个工作日内为您开通权益服务。</p>
                                <p class="bold">细则3</p>
                                <p>享用本服务时，您须出示本人上海农商银行世界白金鑫卡/钛金鑫卡或身份证件配合服务人员进行身份核对，核对无误后，即可享用本服务，不可将本服务转予他人，且接机、送机各计一次。
                                </p>
                                <p class="bold">细则4</p>
                                <p>预约本服务时，您所选择的车型为帕萨特、君越、凯美瑞等同档次舒适车型或别克GL8商务车型。如遇可选车型暂时无法调配，将提供同档次或以上车型的车辆进行服务；每次服务可预约的车辆仅限一辆5座小轿车(只允许最多乘坐4位乘客)，如需预定7座商务车(只允许最多乘坐6位乘客)，则按使用2次计算。
                                </p>
                                <p class="bold">细则5</p>
                                <p>您要预约全国机场、高铁站接/送服务。需提前24小时通过上海农商银行信用卡微信公众号/信用卡APP权益平台自助预约。预约时需详细提供服务的具体信息,包括您姓名、卡号后8位、接机或送机、航班号、机场、航站楼、地址、时间、服务人数、行李数量等其他信息。</p>
                                <p class="bold">细则6</p>
                                <p>您预约接机/接站或送机/送站服务时间一经确认后，如欲取消或变更行程，须在原约定时间基础上提前3小时告知，否则视同为持卡人已使用了本次服务。服务一经取消或变更，持卡人需依上述流程重新预约。
                                </p>
                                <p class="bold">细则7</p>
                                <p>若本行未及时接到您的航班/车次延误及调整后的航班/车次时间通知，接送服务人员于约定时间到达指定地点后，在1小时内联系无法联系到您，则本服务自动取消，并视同您已使用了本次服务。 </p>
                               
                                <p class="bold">细则8</p>
                                <p>每次免费接/送服务的单程行驶最大距离为80公里（仅限同城使用），且已包含80公里车程内所发生的车辆租金、驾驶员服务费、燃油费、第三者责任险、车损费、机场过路/过桥费、高速公路费、停车费、税金等费用。对于超出服务时间/里程限额的费用，您将按照5元/公里的费用自行承担，不足1公里部分计1公里。
                                </p>
                                <p class="bold">细则9</p>
                                <p>送机/送站服务免费等候15分钟，从您预约时间起计等待时间；接机/接站免费等候时间为1小时，从您航班实际降落/车次到达时间起计等待时间。超过免费等候时间按等待超时标准60元/小时的费用自行承担，不足1小时部分计1小时，最长可提供2小时的有偿等候服务。收费服务的发票由服务人员现场提供或由服务商事后邮寄至您指定地址。
                                </p>
                                <p class="bold">细则10</p>
                                <p>我行所提供的免费全国机场、高铁站接/送服务时间为:00:00-24:00，服务过程中不能经停，您若要中途经停，则按使用2次计算，若您全年机场接/送服务仅剩1次，则您在接/送服务过程中路经停靠，则需追加400元单次接/送服务费。</p>
                                <p class="bold">细则11</p>
                                <p>全国机场、高铁贵宾接/送服务具体覆盖区域请以我行信卡权益平台服务预定显示为准。</p>
                            </div>
                            <div class="banner-detail-btn" @click="qgjcPush"><img
                                    src="@/assets/images/tjx/banner_tjx_qgjc.jpg" alt=""></div>
                            <div class="banner-detail-btn" @click="qgtrainPush"><img
                                    src="@/assets/images/tjx/banner_tjx_train.jpg" alt=""></div>
                        </div>
                        <div v-else class="e-common-frames domestic">
                            <div class="content-body">
                                <div class="top-block block">
                                    <div class="cell-box cell-box-01">
                                        <img src="@/assets/images/detailbjx/bjx_detail_car_01.png" alt=""
                                            class="item-img">
                                        <div class="e-right">
                                            <p class="item-title">境内同城点对点用车</p>
                                            <p class="item-content">
                                                持卡人可享境内同城点对点用车服务，覆盖境内70余家城市，派遣专人专车，接送客户往来于指定出发地与目的地之间的单程服务（标准50公里内同城）。
                                            </p>
                                        </div>
                                    </div>
                                    <div class="cell-box cell-box-02">
                                        <div class="cell-item item-02">
                                            <p class="title">活动内容</p>
                                            <img src="@/assets/images/detailbjx/bjx_detail_table_01.png" alt="">
                                        </div>
                                        <div class="cell-item item-03">
                                            <p class="title">温馨提示：</p>
                                            <p>1、服务期限内单次舒适车50公里服务计1点境内权益；单次商务车50公里服务计2点境内权益。</p>
                                            <p>2、预约和使用服务时请确保您的账户及卡片状态正常。现场接受服务时，请您出示本人的上海农商信用卡或身份证件。</p>
                                        </div>
                                    </div>
                                    <div class="cell-box cell-box-03">
                                        <div class="service-rule">
                                            <p class="title">服务细则</p>
                                            <p>1、请持卡人至少提前5小时通过我行上海农商行信用卡公众号预约本服务，最长可预约自申请之日起30个自然日内的服务。预约时您须详细提供所需服务的具体信息，包括持卡人姓名、联系电话、使用服务的时间、起始地、目的地、服务人数等其他信息。
                                            </p>
                                            <p>2、预约本服务时，持卡人所选择的车型舒适车（只允许最多乘坐4位乘客）；商务车（只允许最多乘坐6位乘客），每次服务同时间段内可预约的车辆仅限一辆。
                                            </p>
                                            <a href="javascript:;" class="show-detail-btn" @click="ShowDetailFirst()"
                                                v-show="isShowBtnFirst">展开详情</a>
                                        </div>

                                        <div class="show-detail-box" v-show="isShowFirst">
                                            <p>3、享用本服务时，持卡人须出示本人上海农商银行信用卡及身份证件配合服务人员进行身份核对，核对无误后，即可享用本服务。本服务可供持卡人本人单独使用或偕同宾客共乘时使用，但不得将该权益转让他人。
                                            </p>
                                            <p>4、持卡人预约的用车服务时间一经确认后，如欲取消或变更行程，须在原约定时间基础上提前2小时告知，否则视同为持卡人已使用了本次服务，并扣减相应权益点数。服务一经取消或变更，持卡人需依上述流程重新预约。
                                            </p>
                                            <p>5、若未及时接到来自持卡人的服务变更通知，服务人员于约定时间到达指定地点后，在1小时内联系不到持卡人，则用车服务自动取消，视同为持卡人已使用了本次服务并扣减相应权益点数。
                                            </p>
                                            <p>6、服务使用结束后，服务人员将请持卡人确认服务记录并签单。</p>
                                            <p>7、本服务的目的地或出发地必须是服务商提供列表中所在城市服务范围。不可跨城市、国家或地区使用服务。</p>
                                            <p>8、服务人员于约定时间到达指定地点后，提供最长30分钟的免费等候服务（从预约时间起计算）。如超过最长免费等候时间且服务商无法与您取得联系，则用车服务自动取消；如须等待超过30分钟，则您须自行承担30分钟以外的超时等候费用，按照60元/小时支付现金或其他服务商接受的方式，不足1小时按1小时收取，超过1小时部分按1元/分钟收取，最长可提供2小时的有偿等候服务。
                                            </p>
                                            <p>9、在服务地点和前往目的地确定后，由服务人员根据当时实际情况选择最为安全、快捷和合理的路线，中途不停靠。您在服务过程中下车即被视作服务已结束，并扣减相应权益点数。
                                            </p>
                                            <p>10、单次点对点用车服务标准为50公里（仅限同城使用），且已包含50公里车程内所发生的车辆租金、驾驶员服务费、燃油费、第三者责任险、车损费、过路/过桥费、高速公路费、停车费、税金等费用。超里程按照5元/公里收费，由客户现场自行支付。
                                            </p>
                                            <p>11、收费服务的发票由服务商事后邮寄至持卡人指定地址。</p>
                                            <p>12、在预订服务时，如服务商了解到持卡人要求的服务距离超出规定范围（限50公里以内），告知超里程收费标准。预订或实际服务过程中，发现持卡人要求超出指定范围之外的服务或有违反本服务规则的需要（例如，持卡人要求中途停车接人；服务人员到指定地点发现非持卡人本人享用服务等），服务商有权直接拒绝并协商调整服务要求；如持卡人拒不接受的，服务商有权不提供服务，已实际派车到场甚或实际发生服务的，服务商有权立即终止服务，并视同持卡人已使用了该次服务，并扣减相应权益点数。
                                            </p>
                                            <p>13、本服务不可转让他人，也不可兑换现金或其他优惠或权益。</p>
                                            <a href="javascript:;" class="hide-detail-btn"
                                                @click="hideDetailFirst()"><img
                                                    src="@/assets/images/collect-icon@2x.png" alt=""></a>
                                        </div>

                                    </div>
                                    <div class="banner-detail-btn" @click="mddbcPush"><img
                                            src="@/assets/images/tjx/banner_tjx_jntc.jpg" alt=""></div>
                                </div>

                            </div>

                        </div>
                    </div>
                </cube-tab-panel>
            </cube-tab-panels>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                selectedLabel: '全国机场、高铁贵宾</br>接/送服务',
                tabs: [{
                    label: '全国机场、高铁贵宾</br>接/送服务',
                    class: true,

                }],
                isShowFirst: false,
                isShowBtnFirst: true,
                isShowSecond: false,
                isShowBtnSecond: true,

            }

        },
        mounted() {
            this.$refs['panel1'][0].$el.style.display = 'none';
        },
        methods: {

            clickHandler(label) {
                //  this.$refs['panel1'][0].$el.style.display='block';
            },
            changeHandler(label) {
                // console.log(label)
                if (label === this.tabs[0].label) {
                    this.tabs[0].class = true;
                    setTimeout(() => {
                        this.$refs['panel1'][0].$el.style.display = 'none';
                    }, 500);
                } else {
                    this.$refs['panel1'][0].$el.style.display = 'block';
                    this.tabs[0].class = false;
                }
            },
            ShowDetailFirst() {
                this.isShowFirst = true;
                this.isShowBtnFirst = false;
            },
            hideDetailFirst() {
                this.isShowFirst = false;
                this.isShowBtnFirst = true;
            },
            showDetailSecond() {
                this.isShowSecond = true;
                this.isShowBtnSecond = false;
            },
            hideDetailSecond() {
                this.isShowSecond = false;
                this.isShowBtnSecond = true;
            },
            qgjcPush() {
                this.$test('bjx qgjc-banner')
                // console.log('白金鑫全国机场')
                this.$router.push('/servicetable/qgjc')
            },
            qgtrainPush() {
                this.$test('bjx qgtrain-banner')
                // console.log('白金鑫全国火车站')
                this.$router.push('/servicetable/qgtrain')
            },
            mddbcPush() {
                this.$test('bjx mddbc-banner')
                // console.log('白金鑫目的地包车')
                this.$router.push('/servicetable/mddbc')
            }

        }
    }
</script>

<style lang="less" scoped>

</style>